<template>
  <div class="content-container">
    <search-comp>
      <!-- Search Component -->
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Tên tham số</div>
                <div class="child-w-80">
                  <input
                    v-model="searchParam"
                    type="text"
                    placeholder="Nhập thông tin"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll table-container">
      <GridVx
        ref="agGrid"
        :context="context"
        :auto-size-cell="true"
        :columns="columns"
        :rows="rows"
        class="agGrid"
      />
    </div>
  </div>
</template>
<script>
// import bus from '@/utils/bus'
import {
  CellRenderCheckbox,
  CellRenderSelect,
  cellRenderParamsConfig
} from '@/utils/cellRenders.js'
import {
  getListGeneralParameter,
  updateGuestTemplate
} from '@/api/configuration/general/generalParameter.js'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderSelect,
    // eslint-disable-next-line vue/no-unused-components
    cellRenderParamsConfig
  },
  data() {
    return {
      loading: true,
      context: null,
      searchParam: '',
      options: [
        {
          value: '1',
          label: 'Bảng Group/ Group Master Search'
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        },
        {
          value: 'Option4',
          label: 'Option4'
        },
        {
          value: 'Option5',
          label: 'Option5'
        }
      ],
      value: '',
      columns: [
        {
          headerName: 'Tên tham số',
          field: 'name',
          tooltipField: 'name',
          maxWidth: 250
        },
        {
          headerName: 'Giá trị',
          field: 'value',
          headerClass: 'header-cell-center',
          maxWidth: 300,
          cellRenderer: 'cellRenderParamsConfig',
          cellRendererParams: params => {
            let value = params.data.value
            if (value === 'true') {
              value = true
            } else if (value === 'false') {
              value = false
            }
            return {
              value: value
            }
          }
        },
        {
          headerName: 'Mô tả',
          field: 'description',
          tooltipField: 'description'
        }
      ],
      rows: [],
      initRows: []
    }
  },
  watch: {
    searchParam() {
      const a = []
      this.rows = this.initRows.map(item => {
        if (item.name.includes(this.searchParam)) {
          a.push(item)
        }
      })
      this.rows = a
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    async changeInput(id, value) {
      const data = {
        id: id,
        value: value.toString()
      }
      const initRow = this.rows.filter(item => item.id === id)[0]
      if (initRow && initRow.value === value) {
        return
      }
      this.loading = true
      await updateGuestTemplate(data)
        .then(async res => {
          const message = res.message
          this.loading = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          await this.attachData()
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      // bus.$emit('startLoader', { msg: '' })
      this.loading = true
      const data = await getListGeneralParameter(this.searchParams)
      this.loading = false
      // bus.$emit('endLoader')
      this.rows = data.data
      this.initRows = data.data
    }
  }
}
</script>

<style lang="scss">
.table-container {
  margin: 10px 0;
}
.search-item {
  display: flex;
  align-items: center;
  .label {
    margin-right: 10px;
  }
}
</style>
